import $ from "jquery";

window.addEventListener('load', function () {
    const form = $('#controller-images form#image-transform')

    // only execute when transformation form is found
    if (form.length === 0) {
        return
    }

    const data = {
        mediaHost: form.data('media-host'),
        product: form.data('product'),
        source: form.data('image-source'),
        seoName: form.data('image-seo-name'),
        account: form.data('account')
    }

    let updateTimeout = null

    const validateForm = function () {
        let presets = []
        $('.image_transform_preset').each(function () {
            if ($(this).prop('checked')) {
                presets.push($(this).attr('value'))
            }
        })

        let parameters = {}

        $('.image-transform').each(function () {
            let input = $(this)
            let name = input.attr('name')
            let value = null

            if (name.endsWith('_bg')) {
                value = VALIDATORS.validateColorInput(input)
            } else {
                value = input.val()
            }

            if (value) {
                parameters[name] = value
            }
        })

        $('#image_transformation_parameters').val(JSON.stringify(parameters))
        applyParameters(presets, parameters)
    }

    const delayedValidateForm = function () {
        clearTimeout(updateTimeout)
        updateTimeout = setTimeout(validateForm, 500)
    }

    const applyParameters = function (presets, parameters) {
        let format = 'jpg'
        let url = `//${data.mediaHost}/${data.account}/images/${data.product}/${data.source}/image.${format}`

        let transforms = {}

        for (let name in parameters) {
            if (name === 'format_type') {
                format = parameters[name]
                continue
            }

            let value = parameters[name]

            let parts = name.split('_')
            let module = parts[0]
            let param = parts[1]

            if (value) {
                if (!(module in transforms)) {
                    transforms[module] = []
                }

                transforms[module].push(`${param}_${value}`)
            }
        }

        let tmp = []
        for (let preset of presets) {
            tmp.push(`preset;id_${preset}`)
        }

        for (let name in transforms) {
            let params = transforms[name].join(';')
            tmp.push(`${name};${params}`)
        }

        transforms = tmp.join('/')

        if (transforms) {
            url = `//${data.mediaHost}/${data.account}/images/${data.product}/${data.source}/${transforms}/image.${format}`
        }

        $('#transform_url').text(url).attr('href', url)
        $('#preview').attr('src', url)
    }


    $('.image-transform').on('change', delayedValidateForm)
    $('.image-transform').on('keyup', delayedValidateForm)
    $('.image_transform_preset').change(delayedValidateForm)

    validateForm()
})
